module.exports = require("@pb/kit-component-input-v2");